import { instance as apiService } from ".";
import { handleErrors } from "./utils";


export const defaultAddToCartApi = async (categorySlug, productSlug) => {
    try {
      await apiService.post(`/api/rest/v2/products/${categorySlug}/${productSlug}/add-to-cart/?default_choice=true`);
      return true;
    } catch (error) {
      handleErrors(error);
    }
};

export const getCartDataApi = async (empty) => {
  try {
    const res = await apiService.get(`/api/rest/v1/cart/`);
    return res.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const updateAnonEmailApi = async (data) => {
  try {
    await apiService.post("/api/rest/v1/cart/update-user-data/", data);
    return true;
  } catch (error) {
    handleErrors(error);
  }
};

export const submitAddressFormApi = async (data) => {
  try {
    await apiService.post(`/api/rest/v1/cart/update-address/`, data);
    return { success: true };
  } catch (error) {
    if(error.response && error.response.data && error.response.data.error_msg){
      return { error: error.response.data.error_msg }
    }
    handleErrors(error);
  }
};

export const removeItemFromCartApi = async (token) => {
  try {
    await apiService.post(`/api/rest/v1/cart/delete/`, token);
    return true;
  } catch (error) {
    handleErrors(error);
  }
};

export const removeCouponCodeApi = async () => {
  try {
    await apiService.post("/api/rest/v1/cart/coupon/remove/");
    return true;
  } catch (error) {
    handleErrors(error);
  }
};

export const applyCouponCodeApi = async (code, ) => {
  try {
    await apiService.post(`/api/rest/v1/cart/coupon/`, { code });
    return { success: true };
  } catch (error) {
    if (
      error.response &&
      error.response.data &&
      error.response.data.msg &&
      error.response.data.msg.voucher
    ) {
      return { error :  error.response.data.msg.voucher[0] };
    } else {
      return { error :  "Invalid Coupon" };
    }
  }
};

export const createOrderApi = async ({
  content,
  notify_customer,
  prepayment_percentage = 100,
}) => {
  try {
    const res = await apiService.post(`/api/rest/v1/cart/create-order/`, {
      content,
      notify_customer,
      prepayment_percentage,
    });
    return res.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const flushCartApi = async () => {
  try {
    await apiService.post(`/api/rest/v1/cart/flush-cart/`);
    return true;
  } catch (error) {
    console.log(error);
  }
};